import React from "react";
import IEcharts from "echarts-for-react";
class InlinePriceChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.componentDataValue || [],
      option: {
        xAxis: {
          show: false,
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          itemStyle: {
            normal: { color: "#2196F3" }
          }
        },
        yAxis: {
          show: false,
          type: "value"
        },
        grid: {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          height: 30,
          width: 60
        },
        series: [
          {
            color: "#adadae",
            data: [120, 200, 150, 80, 70, 110, 130],
            type: "bar",
            barWidth: "5",
            barCategoryGap: "10%"
          }
        ]
      },
      loading: true
    };
  }
  render = () => [
    <IEcharts
      key={1}
      // loading={this.state.loading}
      resizable
      option={this.state.option}
    />
  ];
}
export default InlinePriceChart;
